import React from 'react';
import bigThanksDesktop from '../../../../../images/verizon/email_app/progress/big-thanks-desktop.webp';
import bigThanksMobile from '../../../../../images/verizon/email_app/progress/big-thanks-mobile.webp';
import ProgressHeader from './components/progressHeader';
import ProgressFooter from './components/progressFooter';

// BUZZ-3479: Cell 4 "Gratitude" email with the heart hero.
const VerizonProgressGratitude = ({ emailData }) => {
  const { name, receiver } = emailData;

  return (
    <div className="email email-progress">
      <ProgressHeader />

      {/* BUZZ-3481: cropped from the client PDFs (720 = desktop, 360 = mobile) so the words sit
          against the heart exactly as in the original; <picture> swaps the crops at 768px. */}
      <picture className="email-progress_hero">
        <source media="(max-width: 768px)" srcSet={ bigThanksMobile } />
        <img className="email-progress_hero-image" src={ bigThanksDesktop } alt="Big thanks" />
      </picture>

      <div className="email-progress_section email-progress_gratitude-body">
        <h2 className="email-progress_gratitude-greeting">
          Hey <span className="email-progress_gratitude-name">{ name }</span>,
        </h2>
        <p>
          We know you have choices, and we’re glad you chose us for your mobile service.
          { ' ' }
          Thank you for letting us keep you seamlessly connected to your world.
        </p>
        <p>
          Let’s make sure you get the most from us. Have you heard about Verizon Dollars and
          { ' ' }
          Verizon Shine? We hope you are making the most of the program. You can easily do this by
          { ' ' }
          turning on app notifications so you won’t miss any of your daily deals or our epic giveaways.
        </p>
        <p>
          Plus, make your experience with us even better with great products and services like
          { ' ' }
          Verizon Family, Call Filter, streaming and entertainment Perks, presale ticket access and
          { ' ' }
          so much more.
        </p>
        <div className="email-progress_button -big-margin">Check the app</div>
      </div>

      <div className="email-progress_divider" />

      <ProgressFooter receiver={ receiver } />
    </div>
  );
};

export default VerizonProgressGratitude;
